var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-3 col-xl-2 b-sidebar d-none d-lg-block  "},[_c('SideBarContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }